import React, { CSSProperties, useState } from "react";
import { Box, Dropdown, DropdownItem } from "fds";
import utilsCommon from "../../shared/utils/common";
import DatePickerModal from "../DateFilter";
import { t } from "i18next";
import classNames from "classnames";
interface DateDropdownProps {
  classes?: string;
  style?: CSSProperties;
  buttonClick: number;
  filter: any;
  showValue?: boolean;
  dateFilter: string;
  isClient?: boolean;
  initValue?: string;
  placeholder?: string;
  positionStrategy?: "fixed" | "absolute";
  changeFilterByKey: (key: string, val: any) => void;
  setButtonClick: (click: number) => void;
  changeDateFilter?: (newFilter: string) => void;
}

const DateDropdown: React.FC<DateDropdownProps> = ({
  filter,
  buttonClick,
  dateFilter,
  isClient = false,
  showValue = true,
  initValue = "all",
  positionStrategy = "absolute",
  placeholder = t("common.period.title"),
  setButtonClick,
  changeFilterByKey,
  classes,
  style,
}) => {
  const DATE_FILTER = [
    { resource: t("common.period.all"), key: "all" },
    { resource: t("common.period.lastday"), key: "1day" },
    { resource: t("common.period.lastWeek"), key: "1week" },
    { resource: t("common.period.lastMonth"), key: "1month" },
    { resource: t("common.period.lastThreeMonth"), key: "3months" },
    { resource: t("common.period.lastSixMonth"), key: "6months" },
    { resource: t("common.period.lastYear"), key: "1year" },
    { key: "divider" },
    {
      resource: t("common.period.userRange"),
      key: "custom",
    },
  ];
  const [showCustomDateFilter, toggleShowCustomDateFilter] = useState(false);

  return (
    <>
      {showCustomDateFilter && (
        <DatePickerModal
          open={showCustomDateFilter}
          date={filter.date}
          isClient={isClient}
          onSubmit={(req) => changeFilterByKey("date", req)}
          onClose={() => toggleShowCustomDateFilter(false)}
        />
      )}
      <Dropdown
        btnStyle="round"
        placeholder={placeholder}
        buttonWidth={224}
        btnSize="rd"
        positionStrategy={positionStrategy}
        classes={classNames("mg ml-12", classes)}
        buttonClick={buttonClick}
        showValue={showValue}
        defaultValue={initValue}
        selectValue={dateFilter}
        value={
          dateFilter === "custom"
            ? utilsCommon.renderDateFormat(
                filter.date?.start ??
                  filter.startDate ??
                  filter.searchDate?.start,
                "YYYY-MM-DD"
              ) +
              " ~ " +
              utilsCommon.renderDateFormat(
                filter.date?.end ?? filter.endDate ?? filter.searchDate?.end,
                "YYYY-MM-DD"
              )
            : DATE_FILTER.filter((item) => item.key === dateFilter)[0].resource
        }
      >
        {DATE_FILTER.map((item) => (
          <DropdownItem
            state={item.key === "divider" ? "divider" : "default"}
            type="check"
            height={item.key === "divider" ? undefined : 20}
            label={item.resource}
            checked={dateFilter === item.key}
            checkColor={dateFilter === item.key}
            onClick={() => {
              setButtonClick(buttonClick + 1);
              item.key === "custom"
                ? toggleShowCustomDateFilter(true)
                : changeFilterByKey && changeFilterByKey("date", item.key);
            }}
          />
        ))}
      </Dropdown>
    </>
  );
};
export default DateDropdown;
